import axiosClient, { ApiResponse, axiosCustomError } from "./api";
import { ITTLT_Phong } from "./TTLT_PhongService";

export interface ITTLT_Tang {
    id: number;
    ten: string;
    coSoLuuTruId: number;
    thuTu: number | null;
    suDung: boolean;
    phong: Array<ITTLT_Phong> | null;
}

export default class TTLT_TangService {
    static async listAll(coSoLuuTruId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tang/All/${coSoLuuTruId}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async sitemap(coSoLuuTruId: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tang/Sitemap/${coSoLuuTruId}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async filter(coSoLuuTruId: number, pageIndex: number, pageSize: number, keyword: string) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tang/${coSoLuuTruId}?keyword=${keyword}&pageSize=${pageSize}&pageIndex=${pageIndex}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async get(coSoLuuTruId: number, id: number) {
        try {
            const { data } = await axiosClient.get<ApiResponse>(`/api/Tang/${coSoLuuTruId}/${id}`);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async delete(coSoLuuTruId: number, id: number) {
        try {
            const { data } = await axiosClient.delete<ApiResponse>(`/api/Tang/${coSoLuuTruId}/${id}`, {

            });

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async update(id: number, itemData: ITTLT_Tang) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/Tang/${id}`, itemData);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async create(itemData: ITTLT_Tang) {
        try {
            const { data } = await axiosClient.post<ApiResponse>(`/api/Tang/Create`, itemData);

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }

    static async changeIsUsedItem(coSoLuuTruId: number, id: number, suDung: boolean) {
        try {
            const { data } = await axiosClient.put<ApiResponse>(`/api/Tang/ChangeIsUsedItem/${coSoLuuTruId}`, { id, suDung });

            return data;
        } catch (error) {
            return axiosCustomError(error);
        }
    }
}